
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11209",
                "data-name": "矩形 11209",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(334 404)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_249",
        "data-name": "蒙版组 249",
        "class": "cls-2",
        "transform": "translate(-334 -404)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "yigui",
            "class": "cls-3",
            "d": "M91.859,0A.921.921,0,0,1,92.8.9V17.55a.471.471,0,0,1-.941,0v-.9H77.741v.9a.471.471,0,0,1-.941,0V.9a.921.921,0,0,1,.941-.9ZM82.447,13.05H77.741V15.3a.461.461,0,0,0,.471.45h3.765a.461.461,0,0,0,.471-.45Zm9.412,0H83.388V15.3a.461.461,0,0,0,.471.45h7.529a.461.461,0,0,0,.471-.45Zm-11.294.9a.45.45,0,1,1,0,.9h-.941a.45.45,0,1,1,0-.9Zm7.529,0a.45.45,0,1,1,0,.9H86.682a.45.45,0,1,1,0-.9ZM81.977.9H78.212a.461.461,0,0,0-.471.45v10.8h4.706V1.35A.461.461,0,0,0,81.977.9Zm9.412,0H83.859a.461.461,0,0,0-.471.45v10.8h8.471V1.35A.461.461,0,0,0,91.388.9ZM81.035,5.4a.461.461,0,0,1,.471.45v.9a.471.471,0,0,1-.941,0v-.9A.461.461,0,0,1,81.035,5.4Zm3.765,0a.461.461,0,0,1,.471.45v.9a.471.471,0,0,1-.941,0v-.9A.461.461,0,0,1,84.8,5.4Z",
            "transform": "translate(261.2 407)"
          }
        }
      ]
    }
  ]
})
    }
  